export default "__VITE_ASSET__CTGtGPpI__"